/* src/app/features/prestacao-informacoes/acompanhamento-depr/acompanhamento-depr-cadastro/acompanhamento-depr-stepper/acompanhamento-depr-stepper.component.scss */
::ng-deep .app-acompanhamento-depr-stepper .bn-stepper-circle {
  cursor: pointer;
}
::ng-deep .app-acompanhamento-depr-stepper .bn-stepper-name {
  cursor: pointer;
  font-size: smaller;
}
/*# sourceMappingURL=acompanhamento-depr-stepper.component.css.map */
